import PropTypes from "prop-types"
import { useSelector } from "react-redux"

import { enableKlarnaCheckout } from "helpers/checkout/checkout_options"

import Affirm from "./affirm"
import Klarna from "./klarna"

const Financing = ({ price }) => {
  const cartTotal = useSelector((state) =>
    state.cart.summary ? state.cart.summary.cart_total : 0
  )
  const wizardLoading = useSelector((state) => state.wizard.loading)

  if (price <= 0 || wizardLoading) {
    return null
  }

  return (
    <>
      {/* US only */}
      {sl.config.enable_affirm && <Affirm price={price} />}
      {/* Non-US */}
      {sl.config.klarna_osm_pdp &&
        enableKlarnaCheckout() &&
        cartTotal <= sl.config.klarna_max && <Klarna price={price} />}
    </>
  )
}

Financing.propTypes = {
  price: PropTypes.number,
}

export default Financing
